/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BlobWithUrl
 */
export interface BlobWithUrl {
    /**
     * 
     * @type {string}
     * @memberof BlobWithUrl
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof BlobWithUrl
     */
    size: number;
    /**
     * 
     * @type {string}
     * @memberof BlobWithUrl
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof BlobWithUrl
     */
    relativePath: string;
}

/**
 * Check if a given object implements the BlobWithUrl interface.
 */
export function instanceOfBlobWithUrl(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "key" in value;
    isInstance = isInstance && "size" in value;
    isInstance = isInstance && "url" in value;
    isInstance = isInstance && "relativePath" in value;

    return isInstance;
}

export function BlobWithUrlFromJSON(json: any): BlobWithUrl {
    return BlobWithUrlFromJSONTyped(json, false);
}

export function BlobWithUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlobWithUrl {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': json['key'],
        'size': json['size'],
        'url': json['url'],
        'relativePath': json['relative_path'],
    };
}

export function BlobWithUrlToJSON(value?: BlobWithUrl | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'size': value.size,
        'url': value.url,
        'relative_path': value.relativePath,
    };
}

